import { render } from "./participantsDropdown.vue?vue&type=template&id=20352183&scoped=true"
import script from "./participantsDropdown.vue?vue&type=script&lang=js"
export * from "./participantsDropdown.vue?vue&type=script&lang=js"

import "./participantsDropdown.vue?vue&type=style&index=0&id=20352183&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20352183"]])

export default __exports__